import { render, staticRenderFns } from "./OpprRec.vue?vue&type=template&id=b966153c&lang=pug&"
import script from "./OpprRec.vue?vue&type=script&lang=js&"
export * from "./OpprRec.vue?vue&type=script&lang=js&"
import style0 from "./OpprRec.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports